/* Badass Banners 2026: link fixes (loaded on every page from layout/theme.liquid) */
(function(){
  /* ---------- Links: mobile-drawer same-page anchors + keep the theme preview alive ---------- */
  // 1) In the mobile menu drawer, "/#sizes" and "/#faq" on the homepage only scrolled the page *behind* the
  //    open drawer, so the tap looked dead. Close the drawer first, then scroll.
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest && e.target.closest('header-drawer a[href*="#"], .menu-drawer a[href*="#"]');
    if (!a) return;
    var u; try { u = new URL(a.href, location.href); } catch(_) { return; }
    if (u.origin !== location.origin || u.pathname !== location.pathname || !u.hash) return;
    var target = document.getElementById(decodeURIComponent(u.hash.slice(1)));
    if (!target) return;
    e.preventDefault();
    var hd = a.closest('header-drawer') || document.querySelector('header-drawer');
    var det = hd && hd.querySelector('details.menu-drawer-container, details');
    var sum = det && det.querySelector('summary');
    if (det && det.hasAttribute('open') && sum) sum.click();   // let Dawn close it (overlay, body lock, focus)
    var tries = 0;
    (function cleanup(){   // fallback if the theme script didn't finish closing
      if (det && det.hasAttribute('open') && ++tries < 10) return setTimeout(cleanup, 60);
      if (det) { det.classList.remove('menu-opening'); det.removeAttribute('open'); }
      var sec = document.querySelector('.section-header.menu-open'); if (sec) sec.classList.remove('menu-open');
      document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile', 'overflow-hidden');
    })();
    setTimeout(function(){ target.scrollIntoView({ behavior: 'smooth', block: 'start' }); try { history.pushState(null, '', u.hash); } catch(_) {} }, 650);
  });
  // 2) Preview only: Shopify strips ?preview_theme_id after the first page and keeps the preview in a cookie.
  //    Browsers that drop or partition that cookie (in-app browsers, private/strict modes, some shared links)
  //    fell back to the LIVE theme on the next click, where our new URLs (?view=templates, 3x5, etc.) look broken.
  //    On an unpublished theme, carry the id on every internal link. No effect once the theme is published (role "main").
  var TH = window.Shopify && window.Shopify.theme;
  if (TH && TH.id && TH.role && TH.role !== 'main' && !window.Shopify.designMode){
    var keep = function(e){
      var a = e.target && e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var u; try { u = new URL(a.getAttribute('href'), location.href); } catch(_) { return; }
      if (u.origin !== location.origin) return;
      if (/^\/(apps|checkout|checkouts|account|services|admin|cdn)\b|^\/cart\//.test(u.pathname)) return;
      if (u.pathname === location.pathname && u.search === location.search && u.hash) return;
      if (u.searchParams.get('preview_theme_id')) return;
      u.searchParams.set('preview_theme_id', TH.id);
      a.setAttribute('href', u.pathname + u.search + u.hash);
    };
    document.addEventListener('click', keep, true);
    document.addEventListener('auxclick', keep, true);
    document.addEventListener('contextmenu', keep, true);
  }
})();
